<div class="dashboard">
  <header-cmp></header-cmp>
  <div class="dashboard__content">
    <div class="dashboard__padded-content">
      <router-outlet></router-outlet>
    </div>
  </div>
  <div *ngIf="(popup$ | async)?.isPopup" class="page-popup">
    <popup-cmp
      [message]="(popup$ | async)?.message"
      [isOk]="(popup$ | async)?.isOk"
      [isDelete]="(popup$ | async)?.isDelete"
      (action)="onPopupAction($event)"
      [isLoading]="(popup$ | async)?.isLoading"
      [loadingMessage]="(popup$ | async)?.loadingMessage"
    ></popup-cmp>
  </div>
</div>
